if (!customElements.get("product-form-checkout")) {
  customElements.define(
    "product-form-checkout",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        $(".select-error").remove();
        var proceed = true;
        $("variant-selects").each(function () {
          if ($(this).find("select").val() == "select") {
            $(this)
              .after(`<div class="select-error select-error-size caption_2" style="color:#d61530;    margin: -14px 0px 1.5rem;">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        class="icon icon-error"
                        viewBox="0 0 12 12"
                        style="height: 13px;margin-right:5px;"
                      >
                        <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>
                        <circle cx="6.5" cy="6.5" r="5.5" fill="#d61530" stroke="#d61530" stroke-width="0.7"/>
                        <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/>
                        <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#d61530" stroke-width="0.7">
                      </svg>
                      <span class="errormsg detail_8 mobile_body_8" style="font-size:14px;">Required</span>
                    </div>`);
            proceed = false;
          }
        });
         
          $("variant-radios").each(function () {
            if ($("variant-radios").find("input:checked").length == 0) {
              $(this)
                .after(`<div class="select-error select-error-size caption_2" style="color:#d61530; margin: -14px 0px 1.5rem; ">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        class="icon icon-error"
                        viewBox="0 0 12 12" style="height: 13px;margin-right:5px;"
                      >
                        <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>
                        <circle cx="6.5" cy="6.5" r="5.5" fill="#d61530" stroke="#d61530" stroke-width="0.7"/>
                        <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/>
                        <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#d61530" stroke-width="0.7">
                      </svg>
                      <span class="errormsg detail_8 mobile_body_8" style="font-size:14px;">Required</span>
                    </div>`);
              proceed = false;
            }
          });
        

        if (proceed == false) {
          return;
        }

        var this2 = this;
        if (
          $('.included-component-wrapper .component-item[data-included="0"]')
            .length != 0
        ) {
          var items = [];
          $(
            '.included-component-wrapper .component-item[data-included="0"]'
          ).each(function () {
            if ($(this).find(".component-qty-main").val() != 0) {
              var jsob = {};
              jsob["id"] = $(this).data("productid");
              jsob["quantity"] = $(this).find(".component-qty-main").val();
              items.push(jsob);
            }
          });
          console.log(items + " gggg");
          if (items.length > 0) {
            let formData = {
              items: items,
            };
            fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            })
              .then((response) => {
                return response.json();
              })
              .then((response) => {
                continuePurchase();
              })
              .catch((error) => {
                console.error("Error:", error);
              });
          } else {
            continuePurchase();
          }
        } else {
          continuePurchase();
        }

        function continuePurchase() {
          this2.handleErrorMessage();

          this2.submitButton.setAttribute("aria-disabled", true);
          this2.submitButton.classList.add("loading");
          this2
            .querySelector(".loading-overlay__spinner")
            .classList.remove("hidden");

          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          var freestr = "";
          if (
            $('.included-component-wrapper .component-item[data-included="1"]')
              .length != 0
          ) {
            $(
              '.included-component-wrapper .component-item[data-included="1"]'
            ).each(function () {
              var quantity = Number(
                $(this).find(".component-qty-main").attr("step")
              );
              for (let i = 0; i < quantity; i++) {
                freestr = freestr + "," + $(this).attr("data-mainpid");
              }
            });
          }
          if (freestr != "") {
            if ($(".inputincluded").length == 0) {
              $(".product-form__submit").before(
                '<input hidden class="inputincluded" name="properties[_Included]" value="' +
                  freestr.substring(1) +
                  '" type="text"/>'
              );
            }
          }

          const formData = new FormData(this2.form);
          if (this2.cart) {
            formData.append(
              "sections",
              this2.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);

            this2.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this2.handleErrorMessage(response.description);

                const soldOutMessage =
                  this2.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this2.submitButton.setAttribute("aria-disabled", true);
                this2.submitButton
                  .querySelector("span")
                  .classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this2.error = true;
                return;
              } else if (!this2.cart) {
                window.location.href = '/checkout';
                return;
              }

              this2.error = false;
              window.location.href = '/checkout';
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this2.submitButton.classList.remove("loading");
              if (this2.cart && this2.cart.classList.contains("is-empty"))
                this2.cart.classList.remove("is-empty");
              if (!this2.error)
                this2.submitButton.removeAttribute("aria-disabled");
              this2
                .querySelector(".loading-overlay__spinner")
                .classList.add("hidden");
            });
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}